import React, { useEffect, useState } from "react";
import { trackVisit } from "../lib/api";

// Google Ads click-fraud guard.
// - Logs EVERY page load (with traffic source) for admin analytics.
// - Only Google-Ads visitors (gclid) exceeding the monthly visit limit get blocked.
export default function AdGuard({ children }) {
  const [blocked, setBlocked] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const gclid = params.get("gclid") || params.get("gbraid") || params.get("wbraid");
        const utm = params.get("utm_source") || "";
        const res = await trackVisit({
          gclid: gclid || null,
          path: window.location.pathname,
          referrer: document.referrer || "",
          utm_source: utm,
          utm_term: params.get("utm_term") || "",
          utm_campaign: params.get("utm_campaign") || params.get("campaign") || "",
          keyword: params.get("keyword") || params.get("kw") || "",
          query: window.location.search || "",
        });
        if (!cancelled) setBlocked(!!res?.blocked);
      } catch {
        /* fail open — never block genuine users on a network error */
      } finally {
        if (!cancelled) setChecked(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (checked && blocked && !window.location.pathname.includes("/admin")) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#111827", color: "#fff", fontFamily: "Arial, sans-serif", padding: "24px" }} data-testid="ad-blocked-screen">
        <div style={{ maxWidth: 460, textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>&#9888;&#65039;</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 12px" }}>Zugriff vorübergehend eingeschränkt</h1>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#cbd5e1", margin: "0 0 20px" }}>
            Ihre Verbindung wurde aufgrund ungewöhnlicher Aktivität blockiert. Wenn Sie eine Fahrt buchen möchten,
            kontaktieren Sie uns bitte direkt:
          </p>
          <a href="tel:+41791772424" style={{ display: "inline-block", background: "#F5B400", color: "#111", textDecoration: "none", fontWeight: 800, fontSize: 16, padding: "13px 30px", borderRadius: 999 }}>
            +41 79 177 24 24
          </a>
        </div>
      </div>
    );
  }
  return children;
}
